import { Box } from '@chakra-ui/react';

import { TextSemiBold } from 'UiKit/typography';
import useGetHostScheduleDetail from 'Domain/host/useGetHostScheduleDetail';
import { Condition, Iteration } from 'Component/others';

import AchievementCard from 'View/host-detail/component/achievement-card';
import { SkeletonAchievementLive } from 'View/host-detail/component/skeleton';

import styles from './styles.module.css';
import { useTranslation } from 'react-i18next';

const AchievementLive = () => {
  const { t } = useTranslation('host-schedule');
  const { data, isFetching } = useGetHostScheduleDetail();

  return (
    <Condition statement={!isFetching} fallback={<SkeletonAchievementLive />}>
      <Condition statement={data?.hasAchievement}>
        <Box className={styles['achievement-live__container']}>
          <TextSemiBold className={styles['achievement-live__title-text']}>{t('achievement_card.live_achievements')}</TextSemiBold>
          <Iteration items={data?.achievements} render={(achievement) => <AchievementCard {...achievement} key={achievement?.id} />} />
        </Box>
      </Condition>
    </Condition>
  );
};

export default AchievementLive;
